import { FC } from 'react'
import { Skeleton } from '@dtx-company/design-system/src/components/Skeleton/Skeleton'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { usePrintStoreBrandKitQuery } from '@dtx-company/inter-app/src/redux/slices/printStoreApiSlice/printStoreQueries'

export const SkeletonField: FC<{ children: JSX.Element }> = ({ children }) => {
  const { isAuthenticated, isAuthChecked } = useAuthState()
  const { isSuccess } = usePrintStoreBrandKitQuery({}, { skip: !isAuthenticated })

  return (isAuthChecked && !isAuthenticated) || isSuccess ? (
    children
  ) : (
    <Skeleton
      variant="rounded"
      sx={{ display: 'inlineFlex', minWidth: 0, width: '100%', maxWidth: 'unset' }}
    >
      {children}
    </Skeleton>
  )
}
